import { Divider, Grid, makeStyles } from '@material-ui/core';
import React, { Fragment, useEffect, useState, VFC } from 'react';

import { SetValue } from 'containers/DataValidationModal/components/helpers';

import EmploymentHistory, { EmploymentHistoryEntry } from './EmploymentHistory';

const useStyles = makeStyles(() => ({
  employmentHistoryContainer: {
    display: 'grid',
    rowGap: '0.5rem',
  },
}));

export interface EmploymentHistoryContainerProps {
  employmentHistory: EmploymentHistoryEntry[] | null | undefined;
  editDisabled: boolean;
  handleKeyPress: () => void;
  setValue: SetValue;
}

const blankEntry = (): EmploymentHistoryEntry => ({
  city: '',
  state_code: '',
  state_code_iso: '',
  country_code: '',
  country_code_iso: '',
  employer_contact_name: '',
  employer_name: '',
  endMonth: '',
  endYear: '',
  startMonth: '',
  startYear: '',
  job_title: '',
});

export const EmploymentHistoryContainer: VFC<
  EmploymentHistoryContainerProps
> = ({ employmentHistory, editDisabled, handleKeyPress, setValue }) => {
  const [localEmploymentHistory, setLocalEmploymentHistory] = useState<
    EmploymentHistoryEntry[]
  >([]);

  const classes = useStyles();

  useEffect(() => {
    if (Array.isArray(employmentHistory) && employmentHistory.length > 0) {
      setLocalEmploymentHistory(employmentHistory);
    } else if (!editDisabled) {
      setLocalEmploymentHistory([blankEntry()]);
    } else {
      setLocalEmploymentHistory([]);
    }
  }, [employmentHistory, editDisabled]);

  const handleSetValue = (newValue: EmploymentHistoryEntry, idx: number) => {
    const newData = localEmploymentHistory.map((entry, index) => {
      if (index === idx) {
        return newValue;
      }

      return entry;
    });

    setValue(newData);
  };

  return (
    <Grid className={classes.employmentHistoryContainer}>
      {localEmploymentHistory.map((entry, index) => {
        return (
          // eslint-disable-next-line react/no-array-index-key
          <Fragment key={`employment-history-${index}`}>
            {index > 0 && <Divider />}
            <EmploymentHistory
              employmentHistory={entry}
              editDisabled={editDisabled}
              handleKeyPress={handleKeyPress}
              setValue={handleSetValue}
              index={index}
            />
          </Fragment>
        );
      })}
    </Grid>
  );
};

export default EmploymentHistoryContainer;
